import React from 'react';
import {StyleSheet, View, Text, StyleProp, ViewStyle} from 'react-native';
import {colors} from 'src/assets';
import {toCurrency} from 'src/utils/formatter';

export type AmountBannerProps = {
  containerStyle?: StyleProp<ViewStyle>;
  text: string;
  value: number;
};

export const AmountBanner: React.FC<AmountBannerProps> = ({
  containerStyle,
  text,
  value,
}) => {
  return (
    <View style={[styles.root, containerStyle]}>
      <Text style={styles.label}>{text}</Text>
      <Text style={styles.value}>￥{toCurrency(value)}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: colors.white,
    borderRadius: 4,
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  label: {
    fontSize: 12,
    fontWeight: 'bold',
    color: colors.chokuBlack,
  },
  value: {
    fontSize: 30,
    fontWeight: 'bold',
    color: colors.chokuRed,
  },
});
